import { Users } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { T } from "./clients-widget.i18n";
import { KeyFigureValue } from "./key-figure-value";
import { StatsCard } from "./stats-card";

export function ClientsWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("clients", target);
  const t = useT(T);
  const { count } = useDashboardFormat();
  return (
    <StatsCard
      icon={Users}
      label={t.totalClients}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && count(data.total)}
        </KeyFigureValue>
      }
      trend={
        data && data.newThisMonth > 0
          ? { value: data.newThisMonth, label: t.newThisMonth, positive: true }
          : undefined
      }
    />
  );
}
